import SectionHeading from "../../components/Typography/SectionHeading";

function About() {
  return (
    <section id="about" className="container pt-16 tablet:py-0">
      <SectionHeading text="About" />

      <div className="mx-auto max-w-2xl px-6 pb-24 tracking-wider font-semibold">
        <p className="mb-4 leading-relaxed">
          I'm a Full-Stack Software Engineer with over four years of
          experience building SaaS products, enterprise integrations, and
          customer-facing web applications.
        </p>
        <p className="mb-4 leading-relaxed">
          Throughout my career, I've worked across React, Angular, Vue,
          Node.js, and cloud-based platforms, helping teams deliver scalable
          solutions that solve real business problems. My experience spans
          everything from developing customer-facing features and internal
          tooling to designing integration architectures that automate
          complex workflows and improve operational efficiency.
        </p>
        <p className="leading-relaxed">
          I enjoy working at the intersection of product, engineering, and
          business, translating requirements into practical technical
          solutions that create measurable impact. Whether I'm building a
          new feature, integrating external systems, or modernising existing
          platforms, I focus on delivering maintainable, user-focused
          software that drives outcomes.
        </p>
      </div>
    </section>
  );
}

export default About;
